import { SidebarType } from '../../types/Sidebar'

import BookingEditHeader from './booking/BookingHeader'
import Title from './common/Title'

import { useSidebar } from '@/hooks/useSidebar'

const Header = () => {
  const { sidebar } = useSidebar()

  const titles = {
    [SidebarType.BOOKING_EDIT]: <BookingEditHeader />,
    [SidebarType.BOOKING_CREATE]: <Title icon="pi-user-plus" title="Reservierung erstellen" />,
    [SidebarType.ABSENCE]: <Title icon="pi-calendar-plus" title="Abwesenheit eintragen" />,
    [SidebarType.ABSENCE_EDIT]: <Title icon="pi-calendar" title="Abwesenheit bearbeiten" />,
    [SidebarType.EVENT]: <Title icon="pi-calendar-plus" title="Event eintragen" />,
    [SidebarType.EVENT_EDIT]: <Title icon="pi-calendar" title="Event bearbeiten" />,
    [SidebarType.FAST_CHECKIN]: <Title icon="pi-bolt" title="Neuer Walk-In" />,
  }

  if (sidebar.open && titles[sidebar.type]) {
    return <div className="w-full text-start text-2xl font-bold">{titles[sidebar.type]}</div>
  }
  return null
}

export default Header
